import { useEffect } from 'react';

const useClick2Buy = (dependencies = []) => {
    useEffect(() => {
        // Function to initialize Click2Buy widgets
        const initializeClick2Buy = () => {
            if (window.c2bWidget) {
                if (typeof window.c2bWidget.init === 'function') {
                    window.c2bWidget.init();
                }

                // Try to trigger widget detection by dispatching events
                const widgets = document.querySelectorAll('[data-c2buy]');
                widgets.forEach(widget => {
                    // console.log(widget);
                    // Dispatch custom events that Click2Buy might listen for
                    widget.dispatchEvent(new Event('click2buy:init'));
                    widget.dispatchEvent(new Event('widget:init'));
                });
            }
        };

        // Delay initialization to ensure DOM is ready
        const timer = setTimeout(() => {
            initializeClick2Buy();

            // Try again after a longer delay in case the first attempt failed
            setTimeout(initializeClick2Buy, 1000);
        }, 300);

        return () => clearTimeout(timer);
    }, dependencies);
};

export default useClick2Buy;